import { render } from "./FormPerkiraanAccount.vue?vue&type=template&id=485ef417"
import script from "./FormPerkiraanAccount.vue?vue&type=script&lang=js"
export * from "./FormPerkiraanAccount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__